export interface IWidgetResizableEventTarget extends IWidgetSortableEventTarget {
    addEventListener(type: "resizablestart", listener: (ev: CustomEvent) => any, useCapture?: boolean): void;
    addEventListener(type: "resizabledrag", listener: (ev: IWidgetResizeEvent) => any, useCapture?: boolean): void;
    addEventListener(type: "resizableend", listener: (ev: CustomEvent) => any, useCapture?: boolean): void;
    addEventListener(type: string, listener: any, useCapture?: boolean): void;
}

export interface IWidgetSortableEventTarget extends IWidgetSwipeEventTarget {
    addEventListener(type: "sortablestart", listener: (ev: IWidgetSortableStartEvent) => any, useCapture?: boolean): void;
    addEventListener(type: "sortabledrag", listener: (ev: IWidgetSortableStopEvent) => any, useCapture?: boolean): void;
    addEventListener(type: "sortablestop", listener: (ev: IWidgetSortableStopEvent) => any, useCapture?: boolean): void;
    addEventListener(type: string, listener: any, useCapture?: boolean): void;
}
export interface IWidgetSwipeEventTarget {
    addEventListener(type: "widgetSwipe", listener: (ev: IWidgetTouchSwipeEvent) => any, useCapture?: boolean): void;
    addEventListener(type: string, listener: EventListenerOrEventListenerObject, useCapture?: boolean): void;
}

export interface IBooleanDetailValueEvent extends CustomEvent {
    detail: IBooleanDetailValueEventData;
}

export interface IBooleanDetailValueEventData {
    value: boolean;
}

export interface IStringDetailValueEvent extends CustomEvent {
    detail: IStringDetailValueEventData;
}

export interface IStringDetailValueEventData {
    value: string;
}

export interface IAttributeChangeEvent extends CustomEvent {
    detail: IAttributeChangeEvent;
}

export interface IAttributeChangeEventData {
    attrName: string;
    oldVal: string;
    newVal: string;
}

export interface IWidgetResizeEvent extends CustomEvent {
    detail: {
        width: number;
        height: number;
    };
}

export interface IWidgetTouchSwipeEvent extends CustomEvent {
    detail: {
        direction: string;
    };
}

export interface IWidgetSortableStopEvent extends CustomEvent {
    detail: {
        element: Element;
        ui: JQueryUISortableUIParams;
    };
}

/**Interface pro JQueryUI.SortableUIParams */
export interface JQueryUISortableUIParams {
    helper: any;
    item: any;
    offset: any;
    position: any;
    originalPosition: any;
    sender: any;
    placeholder: any;
}

export interface IWidgetSortableStartEvent extends CustomEvent {
    detail: {
        element: Element;
        placeholder: Element;
    };
}

export interface IFileUploadEvent extends CustomEvent {
    detail: IFileUploadEventData;
}

export interface IFileUploadEventData {
    files: File[];
}

export interface IFileUploadPrevEvent extends CustomEvent {
    detail: IFileUploadPrevEventData;
}

export interface IFileUploadPrevEventData {
    files: File[];
    cancelled?: boolean;
}

/** Událost stažení dokumentu */
export interface IFileDownloadEvent extends CustomEvent {
    detail: IFileDownloadEventData;
}

/** Dodatečné informace potřebné pro stažení dokumentu */
export interface IFileDownloadEventData {
    isArchiveDocument: boolean;
}
